function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import ParagraphWithLogosComponent from "/components/core/paragraph-with-logos/paragraph-with-logos-component";
import { StyledIntegrationsComponent } from "./integrations-component.scss";
const INTEGRATIONS_ASSETS = [
    [
        {
            url: "/static/img/integrations/dropbox.png",
            alt: "Dropbox",
            href: "https://support.monday.com/hc/en-us/articles/115005339505-How-do-I-upload-files-and-attachments-in-monday-com-"
        },
        {
            url: "/static/img/integrations/excel.png",
            alt: "Excel",
            href: "https://support.monday.com/hc/en-us/articles/360000219209-How-to-import-and-export-to-Excel-"
        },
        {
            url: "/static/img/integrations/google_calendar.png",
            alt: "Google Calendar",
            href: "https://support.monday.com/hc/en-us/articles/360001362725-How-can-I-integrate-my-board-with-my-calendar-"
        },
        {
            url: "/static/img/integrations/google_drive.png",
            alt: "Google Drive",
            href: "https://support.monday.com/hc/en-us/articles/115005339505-How-do-I-upload-files-and-attachments-in-monday-com-"
        },
        {
            url: "/static/img/integrations/integromat.png",
            alt: "Integromat",
            href: "https://support.monday.com/hc/en-us/articles/360001265649-How-to-sync-timelines-between-2-boards-with-Integromat"
        },
        {
            url: "/static/img/integrations/slack.png",
            alt: "Slack",
            href: "https://support.monday.com/hc/en-us/articles/360001183089-How-to-use-the-Slack-internal-integration-"
        },
        {
            url: "/static/img/integrations/trello.png",
            alt: "Trello",
            href: "https://support.monday.com/hc/en-us/articles/360000274165-How-can-I-import-my-boards-from-Trello"
        },
        {
            url: "/static/img/integrations/zapier.png",
            alt: "Zapier",
            href: "https://support.monday.com/hc/en-us/articles/115005934989-How-to-create-an-integration-using-Zapier"
        }
    ]
];
class IntegrationsComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledIntegrationsComponent, {
            className: "integrations-component",
            children: /*#__PURE__*/ _jsx("div", {
                className: "paragraph-with-logos-wrapper",
                children: /*#__PURE__*/ _jsx(ParagraphWithLogosComponent, _object_spread_props(_object_spread({}, this.props), {
                    shadow: true
                }))
            })
        });
    }
}
export { IntegrationsComponent as default };
IntegrationsComponent.defaultProps = {
    assets: INTEGRATIONS_ASSETS
};
